<template>
    <!-- 营销订单详情 -->
    <content-view v-show="$utils.renderWhen(this,'marketingOrderDetail')">
        <div class="bg-white marketing-order-detial">
            <a-table :loading="t_loading" bordered :dataSource="dataSource" :columns="columns" :pagination="false" :rowKey="record => record.id">
                <span slot="type" slot-scope="type">{{['','独立售卖商品','定金商品','尾款商品'][type]}}</span>
                <span slot="payState" slot-scope="payState">{{$utils.payState[payState]}}</span>
            </a-table>
            <div class="sub-title">赠送奖品内容：</div>
            <a-table :loading="t_loading" bordered :dataSource="dataSourceGive" :columns="columnsGive" :pagination="false" :rowKey="record => record.id">
                <span slot="prizeType" slot-scope="prizeType">{{['','票券','优惠券','储值卡'][prizeType]}}</span>
                <span slot="status" slot-scope="status">{{['','已赠送','已使用','已禁用'][status]}}</span>
                <template slot="action" slot-scope="a,row">
                    <a-popconfirm
                    v-if="row.status === 1"
                    title="确定禁用吗?"
                    @confirm="activityOrderState(row.id, 1, row.prizeType)"
                    >
                        <a class="text-primary">禁用</a>
                    </a-popconfirm>
                    <a v-if="row.status === 2" class="text-disabled">禁用</a>
                    <a-popconfirm
                    v-if="row.status === 3"
                    title="确定取消禁用吗?"
                    @confirm="activityOrderState(row.id, 0, row.prizeType)"
                    >
                        <a class="text-primary">取消禁用</a>
                    </a-popconfirm>
                </template>
            </a-table>
        </div>
    </content-view>
</template>
<script type="text/javascript">
    import { mapGetters } from "vuex";
    import moment  from 'moment';
    const columns = [
    {
        title: "会员手机号",
        dataIndex: "phone"
    },
    {
        title: "商品名称",
        dataIndex: "name"
    },
    {
        title: "商品规格",
        dataIndex: "speName"
    },
    {
        title: "商品类型",
        dataIndex: "type",
        scopedSlots: { customRender: "type" }
    },
    {
        title: "商品状态",
        dataIndex: "payState",
        scopedSlots: { customRender: "payState" }
    }]
    const columnsGive = [
    {
        title: "会员手机号",
        dataIndex: "phone"
    },
    {
        title: "奖品名称",
        dataIndex: "name"
    },
    {
        title: "奖品类型",
        dataIndex: "prizeType",
        scopedSlots: { customRender: "prizeType" }
    },
    {
        title: "奖品状态",
        dataIndex: "status",
        scopedSlots: { customRender: "status" }
    },
    {
        title: "操作",
        dataIndex: "action",
        scopedSlots: { customRender: "action" }
    }]
    export default {
        name: "marketingOrderDetail",
        components: {},
        props: {},
        data() {
            return {
                columns,
                columnsGive,
                dataSource: [],
                dataSourceGive: [],
                t_loading: true
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        beforeCreate() {
        },
        created() {},
        mounted() {
            this.getList()
        },
        watch: {
            '$route'(val) {
                val.name == 'allOrder' && this.getList();
            }
        },
        methods: {
            // 获取订单详情列表
            getList() {
                this.t_loading = true
                this.$api.changeCode
                .activityOrderDetail({
                    params: {id: this.$route.query.id}
                })
                .then(res => {
                    this.dataSource = [{
                        phone: res.phone,
                        name: res.name,
                        speName: res.speName,
                        type: res.type,
                        payState: res.payState
                    }]
                    this.dataSourceGive = res.giftList
                    this.t_loading = false
                }).catch(err => {
                    this.t_loading = false
                })
            },
            // 禁用／取消禁用
            activityOrderState(id,state,type) {
                this.$api.changeCode
                .activityOrderState({
                    body: {id: id, state: state, type: type}
                })
                .then(res => {
                    this.$message.success('操作成功')
                    this.getList()
                });
            },
        },
    };
</script>
<style lang="scss">
.marketing-order-detial {
    padding: 24px;
    .sub-title {
        padding: 24px;
        font-size: 24px;
    }
}
    .billInfo-refund {
        .red {
            color: rgba(245, 34, 45, 1);
        }
        .border-gray{
            border:1px solid #ddd;
            padding: 16px;
        }
    }
</style>